import Carousel from "./Carousel";
import ProductList from "./ProductList";
import Services from "./Services";
import Categories from "./Categories";
import PageNotFound from "./PageNotFound";
import ProductDetails from "./ProductDetails";
import FAQ from "./FAQ";
import PrivacyPolicy from "./PrivacyPolicy";
import TermCondition from "./TermsConditions";
import CommingSoon from "./CommingSoon";
import BlogList from "./BlogList";
import BlogDetail from "./BlogDetail";
import AddToCart from "./AddToCart";
import Checkout from "./Checkout";
import FilterCard from "./Filtercard";
import HeroSection from "./HeroSection";
import Testimonials from "./Testimonials";
import LogisticService from "./LogisticServices";
import Contact from "./Contactus";
import MultiSection from "./MultiSection";
import OrderDetail from "./OrderDetail";
import VendorForm from "./VendorForm";
import Track from "./Track";
import CourierTestimonials from "./CourierTestimonials";
import Benifits from "./Benefits";
import BranchList from "./BranchList";
import CityList from "./CityList";
import ReliableHeroSection from "./ReliableHeroSection";
import Process from "./Process";
import AboutUs from "./AboutUs";
import ReliableFAQ from "./ReliableFAQ";
import ReliableTestimonial from "./ReliableTestimonial";
import Quote from "./Quote";
import ReliableServices from "./ReliableService";
import ReliableMultiSection from "./ReliableMultiSection";
import OfferSection from "./OfferSection";
import ReliableBlogList from "./ReliableBlog";
import Team from "./Team";
import ServiceDetail from "./ServiceDetail";
import CourierBranchList from "./CourierBranchList";
import ReliableTrack from "./ReliableTack";
import MerchantSignup from "./MerchantSignUp";

export default [
  Carousel,
  ProductList,
  Services,
  Categories,
  ProductDetails,
  PageNotFound,
  FAQ,
  PrivacyPolicy,
  TermCondition,
  CommingSoon,
  BlogList,
  BlogDetail,
  AddToCart,
  Checkout,
  FilterCard,
  HeroSection,
  Testimonials,
  LogisticService,
  Contact,
  MultiSection,
  OrderDetail,
  VendorForm,
  Track,
  CourierTestimonials,
  CourierBranchList,
  Benifits,
  BranchList,
  CityList,
  ReliableHeroSection,
  Process,
  AboutUs,
  ReliableFAQ,
  ReliableTestimonial,
  Quote,
  ReliableServices,
  ReliableMultiSection,
  OfferSection,
  ReliableBlogList,
  Team,
  ServiceDetail,
  ReliableTrack,
  MerchantSignup,
];
